import { useReveal } from "@/hooks/useReveal";
import { UFJ_IMAGES } from "./data";

export default function UFJHero({ onDiscover, onPrivateViewing }) {
  const eyebrow = useReveal();
  const title = useReveal();
  const support = useReveal();
  const cta = useReveal();

  return (
    <section
      id="ufj-hero"
      data-testid="ufj-hero"
      className="relative h-screen min-h-[720px] w-full overflow-hidden bg-black"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <div
          className="pd-hero-bg absolute inset-0"
          style={{
            backgroundImage: `url(${UFJ_IMAGES.hero})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.42) saturate(0.9)",
          }}
        />
        <div className="absolute inset-0 vignette pointer-events-none" />
        <div className="absolute inset-0 grain pointer-events-none" />
      </div>

      {/* Concept imagery disclosure */}
      <div className="absolute top-28 right-6 lg:right-10 z-20">
        <span className="text-[0.55rem] uppercase tracking-[0.42em] text-white/35 border border-white/15 px-3 py-1.5">
          Concept Imagery
        </span>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
          <div className="max-w-3xl">
            <p ref={eyebrow} className="pd-reveal eyebrow" data-testid="ufj-hero-eyebrow">
              PiérrecDavís Maison · Haute Joaillerie
            </p>
            <h1
              ref={title}
              className="pd-reveal mt-6 font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white leading-[1.02] tracking-[0.06em]"
              style={{ transitionDelay: "180ms" }}
              data-testid="ufj-hero-title"
            >
              Ultra Fine <br />
              <span className="text-gold-gradient">Jewelry.</span>
            </h1>
            <p
              ref={support}
              className="pd-reveal mt-8 max-w-xl font-serif-body italic text-lg md:text-xl text-white/75 leading-relaxed"
              style={{ transitionDelay: "360ms" }}
              data-testid="ufj-hero-support"
            >
              Exceptional creations. Extraordinary rarity. An expression of distinction beyond the ordinary.
            </p>

            <div
              ref={cta}
              className="pd-reveal mt-12 flex flex-col sm:flex-row items-start gap-5"
              style={{ transitionDelay: "540ms" }}
            >
              <button
                onClick={onDiscover}
                className="btn-gold"
                data-testid="ufj-hero-discover"
              >
                <span>Discover the Collection</span>
              </button>
              <button
                onClick={onPrivateViewing}
                className="btn-ghost"
                data-testid="ufj-hero-private-viewing"
              >
                Request a Private Viewing
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer line */}
      <div className="absolute bottom-6 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
          <span className="text-[0.6rem] uppercase tracking-[0.42em] text-white/40">
            Monaco · Geneva · Private
          </span>
          <span className="text-[0.6rem] uppercase tracking-[0.42em] text-white/40">
            Rise Above The Ordinary
          </span>
        </div>
      </div>
    </section>
  );
}
